export const setItem = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
}
export const getItem = (key) => {
    const value = localStorage.getItem(key)
    if (value === 'undefined') return undefined;
    return JSON.parse(value)
}
export const removeItem = (key) => {
    return localStorage.removeItem(key);
}
export default {
    setItem,
    getItem,
    removeItem
}
